export interface ModalSpecialInstructionsProps {
  showSpecialInstructions: boolean;
  setShowSpecialInstructions: (value: boolean) => void;
  merchantColor: string;
  setSpecialInstructions: (value: string) => void;
  className: string;
  specialInstructions?: string;
}
export const ModalSpecialInstructions = ({
  showSpecialInstructions,
  setShowSpecialInstructions,
  merchantColor,
  setSpecialInstructions,
  className,
  specialInstructions,
}: ModalSpecialInstructionsProps) => {
  return (
    <div className={className}>
      {!showSpecialInstructions && (
        <button
          onClick={() => {
            setShowSpecialInstructions(true);
          }}
        >
          <p
            className="text-[14px] font-medium hover:underline"
            style={{
              color: merchantColor,
            }}
          >
            Special Instructions +
          </p>
        </button>
      )}
      {showSpecialInstructions && (
        <div className="relative">
          <input
            type="text"
            id="outlined_special_instructions_input"
            className="block text-[16px] px-2.5 h-[58px] py-2.5 w-full text-gray-900 bg-transparent rounded-[4px] border hover:border-black focus:outline-none focus:ring-1 focus:ring-blue border-gray-300 peer"
            maxLength={200}
            value={specialInstructions}
            onChange={(e) => setSpecialInstructions(e.target.value)}
          />
          <label
            htmlFor="outlined_special_instructions_input"
            className="absolute text-md text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-5 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1"
          >
            Special Instructions
          </label>
        </div>
      )}
    </div>
  );
};
